import ChatAIPage from "./components/chat-component";
import ChatsLayout from "./components/chats-layout";

export const ViagsGptPageRoutes = {
  viagsGptPage: {
    path: "/viags-gpt",
    component: () => (
      <ChatsLayout>
        <ChatAIPage />
      </ChatsLayout>
    ),
  },
};
